import { styled } from "@mui/styles"
import Box from "@mui/material/Box"

export const Grid = styled(Box)(() => ({
  display: "grid",
  gridTemplateColumns: "calc(50% - 11px) calc(50% - 11px)",
  columnGap: "22px",
  rowGap: "13px"
}))
